import { fetchGatewayIp } from '@/core/api/fetchGatewayIp.api'
import type { GatewayConfig } from '@/core/api/libraries.api'

import { isIpHostname } from './isIpHostname'

export const resolveVisionIpAddress = async (config: GatewayConfig, hostname: string): Promise<string | undefined> => {
  const fromGateway = await fetchGatewayIp(config)
  if (fromGateway) {
    return fromGateway
  }

  if (!isIpHostname(hostname)) {
    return undefined
  }

  return hostname.replace(/^\[|\]$/g, '')
}
